export enum ActivityType {
  Course = 'course',
  Other = 'other',
}
